export { default } from './ArrayOf2';
